import * as z from "zod";

export const setAuthorizeNetIntegration = {
  name: "setAuthorizeNetIntegration" as const,
  input: z.object({
    loginId: z.string().min(1, "Login ID is required"),
    transactionKey: z.string().min(1, "Transaction key is required"),
    sandboxMode: z.boolean().optional(),
  }),
  output: z.object({}),
};

export type SetAuthorizeNetIntegrationInput = z.infer<
  typeof setAuthorizeNetIntegration.input
>;

export const updateAuthorizeNetIntegration = {
  name: "updateAuthorizeNetIntegration" as const,
  input: z.object({
    loginId: z.string().optional(),
    transactionKey: z.string().optional(),
    sandboxMode: z.boolean().optional(),
    enabled: z.boolean().optional(),
  }),
  output: z.object({}),
};

export type UpdateAuthorizeNetIntegrationInput = z.infer<
  typeof updateAuthorizeNetIntegration.input
>;

export const getAuthorizeNetIntegration = {
  name: "getAuthorizeNetIntegration" as const,
  input: z.object({}),
  output: z.object({
    authorizeNetIntegration: z.optional(
      z.object({ sandboxMode: z.boolean(), enabled: z.boolean() }),
    ),
    hasCustomReturnIntegration: z.boolean(),
  }),
};

export type GetAuthorizeNetIntegrationOutput = z.infer<
  typeof getAuthorizeNetIntegration.output
>;

export const disconnectAuthorizeNetIntegration = {
  name: "disconnectAuthorizeNetIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
